<template>
  <div class="e-status__container">
    <div
      v-for="(step, i) in steps"
      :key="step.id"
      class="e-status"
      :class="
        i === currentStep
          ? 'e-status--active'
          : i < currentStep
          ? 'e-status--success'
          : ''
      ">
      {{ step.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      default: null,
      type: Array,
    },
    currentStep: {
      type: Number,
    },
  },

  data() {
    return {}
  },

  methods: {},
}
</script>
